import { useTranslation } from "react-i18next";
import { useUpdateHead } from "src/hooks";
import { NewsModule } from "src/modules";

const NewsPage = () => {
    const { t } = useTranslation();
    useUpdateHead({
        title: t("links.allnews"),
        description: t("descriptions.allnews"),
    });
    return <NewsModule />;
};
export default NewsPage;
